import { apiGet } from '@/shared/utils/requestBuilder';
import { parseApiResponse } from '@/shared/utils/apiResponse';
import type { NegociacaoGlobal } from '../../types/operacoes';

const BASE_URL = '/admin/negociacoes';

export interface NegociacoesGlobaisParams {
  page?: number;
  limit?: number;
  search?: string;
  escritorioId?: string;
  criadoPorId?: string;
  status?: string;
  periodo?: string;
  dataInicio?: string;
  dataFim?: string;
  sortBy?: string;
  sortOrder?: string;
}

export interface NegociacoesGlobaisStatsParams {
  escritorioId?: string;
  periodo?: string;
  dataInicio?: string;
  dataFim?: string;
}

export interface NegociacoesGlobaisStats {
  total: number;
  ativas: number;
  acordos: number;
  falhas: number;
  cpfsUnicos: number;
}

export interface NegociacoesGlobaisListResponse {
  data: NegociacaoGlobal[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

export const negociacoesGlobaisService = {
  async list(params: NegociacoesGlobaisParams = {}): Promise<NegociacoesGlobaisListResponse> {
    const query = new URLSearchParams();
    if (params.page) query.set('page', String(params.page));
    if (params.limit) query.set('limit', String(params.limit));
    if (params.search) query.set('search', params.search);
    if (params.escritorioId) query.set('escritorioId', params.escritorioId);
    if (params.criadoPorId) query.set('criadoPorId', params.criadoPorId);
    if (params.status) query.set('status', params.status);
    if (params.periodo) query.set('periodo', params.periodo);
    if (params.dataInicio) query.set('dataInicio', params.dataInicio);
    if (params.dataFim) query.set('dataFim', params.dataFim);
    if (params.sortBy) query.set('sortBy', params.sortBy);
    if (params.sortOrder) query.set('sortOrder', params.sortOrder);

    const qs = query.toString();
    const url = qs ? `${BASE_URL}?${qs}` : BASE_URL;
    const response = await apiGet(url);
    return parseApiResponse<NegociacoesGlobaisListResponse>(response);
  },

  async getStats(params: NegociacoesGlobaisStatsParams = {}): Promise<NegociacoesGlobaisStats> {
    const query = new URLSearchParams();
    if (params.escritorioId) query.set('escritorioId', params.escritorioId);
    if (params.periodo) query.set('periodo', params.periodo);
    if (params.dataInicio) query.set('dataInicio', params.dataInicio);
    if (params.dataFim) query.set('dataFim', params.dataFim);

    const qs = query.toString();
    const url = qs ? `${BASE_URL}/stats?${qs}` : `${BASE_URL}/stats`;
    const response = await apiGet(url);
    return parseApiResponse<NegociacoesGlobaisStats>(response);
  },

  async getById(id: string): Promise<NegociacaoGlobal> {
    const response = await apiGet(`${BASE_URL}/${id}`);
    return parseApiResponse<NegociacaoGlobal>(response);
  },
};
